export default __webpack_public_path__ + "static/media/lightSelected.39df10fe.svg";